import * as queries from "./queries"

export default {
  ...queries,
}
